<template>
  <div class="container pt-5">

    <destination-page-template :destination-copy="destinationInfo.data.copy"
                               :bottom-asset="destinationInfo.assets.bottom">
      <div slot="main-image"
           class="destinations-main-image mb-3"
           :style="`background-image: url(${destinationInfo.assets.main.path});
           backgroundSize: ${destinationInfo.assets.main.page.backgroundSize};
           backgroundPositionX: ${destinationInfo.assets.main.page.positionX};
           backgroundPositionY: ${destinationInfo.assets.main.page.positionY}`"></div>
    </destination-page-template>

  </div>
</template>

<script>
  import DestinationPageTemplate from "../../components/destination-page-template";
  import {getDestinationInfo} from "../../constants/destinations";

  export default {
    name: 'Corfu',
    components: {
      DestinationPageTemplate
    },
    computed: {
      destinationInfo: function () {
        return getDestinationInfo('corfu')
      }
    }
  }
</script>

<style scoped lang="scss">

</style>